import type { Session, UserData } from '@cobliteam/common-types';
import type { FeatureFlags } from '@cobliteam/hooks/src/useFeatureFlags';
import { useEffect, useEffectEvent } from 'react';
import { initializeThirdParty } from '../libs/configureThirdParty';

type ThirdPartyFeatureFlags = Pick<FeatureFlags, 'ddRumSampleRate' | 'ddRumReplaySampleRate' | 'oneSignal' | 'useDdRum'> & Partial<FeatureFlags>;

/** Identifica o usuário nos SDKs de terceiros; `initializeThirdParty` ignora chamadas sem mudança de identidade. */
const useInitializeThirdParty = ({ session, userData, featureFlags }: { session: Session; userData?: UserData; featureFlags: ThirdPartyFeatureFlags }) => {
  const initialize = useEffectEvent(() => initializeThirdParty({ session, userData, featureFlags: featureFlags as FeatureFlags }));
  const { ddRumSampleRate, ddRumReplaySampleRate, oneSignal, useDdRum, sidebar, aiChat } = featureFlags;

  // biome-ignore lint/correctness/useExhaustiveDependencies: deps são a identidade que justifica reidentificar
  useEffect(() => {
    initialize();
  }, [
    session.user.id,
    session.user.role,
    session.fleet.id,
    session.fleet.name,
    userData?.userAttributes,
    ddRumSampleRate,
    ddRumReplaySampleRate,
    oneSignal,
    useDdRum,
    sidebar,
    aiChat,
  ]);
};

export default useInitializeThirdParty;
